import { Button } from "../../../components/Button/Button.tsx";
import type { OnboardingStep } from "../types.ts";
import { Stepper } from "./Stepper.tsx";

export const UserOnboardingLayout = ({
  title,
  step,
  progress,
  children,
  onSkip,
}: {
  title: string;
  step: OnboardingStep;
  progress: number;
  children: React.ReactNode;
  onSkip?: () => void;
}) => (
  <div className="flex-col gap-600">
    <div className="flex-col gap-400">
      <Stepper step={step} progress={progress} />
      <div className="heading-3xl">{title}</div>
    </div>
    <div className="flex-col gap-400">
      {children}
      <div className="flex-row justify-end">
        {onSkip && (
          <Button
            size="md"
            variant="secondary"
            iconName="ArrowRight"
            onClick={onSkip}
          >
            Skip this step
          </Button>
        )}
      </div>
    </div>
  </div>
);
